export enum EResourceType {
  Template = 'Template',
  ContentLink = 'ContentLink',
  Video = 'Video',
  Editor = 'Editor',
}
